@if (!isSalesPeriod && !isEvent && !isInitiative) {
  <div>
    {{'EVENT.DETAILS.PURCHASE-RIGHT.IMPOSSIBLE.TITLE' | translate}}
  </div>
} @else {
  <t4-list-view #listVw [options]="listOptions" (onDataRequest)="OnDataRequest($event)">
    <ng-container *t4ListActions>
      <div class="object-actions bg-white text-end">
        <button (click)="actionClick('check')" class="btn btn-primary border btn-small" type="button"><i class="fa fa-address-card"></i>{{'GENERIC.BUTTON.CHECK' | translate}}</button>
        @if (!isInArchiveMode) {
          <button (click)="actionClick('add')" class="btn btn-primary border btn-small" type="button"><i class="far fa-edit"></i>{{ 'GENERIC.BUTTON.ADDNEW' | translate}}</button>
        }
      </div>
    </ng-container>
    <ng-container *t4ListItem="let item">
      <th scope="row">{{item.Id}}</th>
      <td>{{ item.AvailableFrom | localDateTime }}</td>
      <td>{{ item.AvailableTill | localDateTime }}</td>
      @if (isEvent) {
        <td>{{ item.SaleCategoryName }}</td>
      }
      @if (isSalesPeriod) {
        <td>{{ item.TargetPassePartoutName }}</td>
      }
      @if (isInitiative) {
        <td>{{ item.TargetEventName ? item.TargetEventName + ' (' + item.SaleCategoryName + ')' : item.TargetPassePartoutName }}</td>
      }
      <td>{{ showRightsFor(item.TagName, item.OriginPassePartoutName) }}</td>
      <td>{{ item.SalesChannelName }}</td>
      <td>{{ showAmount(item.UnlimitedAmount, item.AmountPerTicket, item.AmountAbsolute) }}</td>
      <td><t4-list-value-boolean [value]="item.Transferable"> </t4-list-value-boolean></td>
      @if (isSalesPeriod) {
        <td><t4-list-value-boolean [value]="item.IsPrimary"> </t4-list-value-boolean></td>
      }
      @if (isSalesPeriod) {
        <td><t4-list-value-boolean [value]="item.IsAlternative"> </t4-list-value-boolean></td>
      }
      @if (isSalesPeriod) {
        <td><t4-list-value-boolean [value]="item.IsCrossSell"> </t4-list-value-boolean></td>
      }
      <td class="grid-action" >
        <button (click)="actionClick('edit', item)" type="button" class="btn btn-grid btn-round mdi mdi-info mdi-lead-pencil"></button>
        @if (!isInArchiveMode) {
          <button (click)="actionClick('delete', item)" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
        }
      </td>
    </ng-container>
  </t4-list-view>
}

